export const Config = {
  env: process.env.XP_HUB_PERMISSION_ENV,
};

export const Permissions = {
  SIGN_TERM: 'XP.Intranet#Hub_Web#Dashboard_Termo_AdicionarTermo',
};



// WEBPACK FOOTER //
// ./src/utils/permissions/index.js